export default __webpack_public_path__ + "static/media/software_light_mobile.ca974b60.svg";